import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import RequiredFieldMessage from "../common/userMessages/requiredFieldMessage";
import TaskComplete from "../common/taskComplete";
import userService from "../../services/userService";
import ResidenceForm from "../forms/pageForms/residenceForm";
import { getResidenceInputs } from "../forms/formEntities/residenceEntities";
import { useTranslation, Trans } from "react-i18next";
// import ModalComponent from "../common/modal";
import SaveAndContinueUserMessage from "../common/userMessages/saveAndContinueMessage";
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";

export default function Residences({
  user,
  userData,
  updatePage,
  shake,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const residenceInputs = getResidenceInputs(t);
  const [residences, setResidences] = useState([]);
  const [extendedAddress, setExtendedAddress] = useState(false);
  const [showPageReqsMessage, setShowPageReqsMessage] = useState(false);
  const [minYear, setMinYear] = useState();

  const [modalShow, setModalShow] = useState(false);
  const onModalHide = () => {
    setModalShow(false);
    setExtendedAddress(false);
  };

  // Check if user has actually lived at current address for 7 years
  const canUseSevenYearCheckbox = () => {
    if (!userData.empInfo || !userData.empInfo.physicalAddress1) {
      return false;
    }

    // Get current date
    const currentDate = new Date();
    const sevenYearsAgo = new Date();
    sevenYearsAgo.setFullYear(currentDate.getFullYear() - 7);

    // Check if any residence history exists that would indicate they haven't been at current address for 7 years
    if (residences && residences.length > 0) {
      // If they have residence history, they can't use the 7-year checkbox
      return false;
    }

    return true;
  };

  const handleExtendedAddress = (test) => {
    if (!canUseSevenYearCheckbox()) {
      // Don't allow checking if they haven't lived there for 7 years
      return;
    }
    setExtendedAddress(!extendedAddress);
    setModalShow(true);
  };

  const handleSkipStep = async () => {
    let residence = {
      address1: userData.empInfo.physicalAddress1,
      address2: userData.empInfo.physicalAddress2,
      city: userData.empInfo.physicalCity,
      state: userData.empInfo.physicalState,
      zip: userData.empInfo.physicalZip,
      fromDate: "Extended Residence",
      tillDate: "Current",
    };
    const updatedResidenceInfo = {
      isComplete: true,
      extendedResidence: extendedAddress,
      residences: [residence],
    };
    userData.residenceInfo = updatedResidenceInfo;
    updatePage();
    navigate("../phase2-employers");

    await userService.saveUserData(user, "residenceInfo", updatedResidenceInfo);
  };

  const handlePageReqs = (data) => {
    if (data) {
      let formYear = data.fromDate.slice(-4);
      if (parseInt(formYear) <= parseInt(minYear)) {
        setShowPageReqsMessage(false);
        return true;
      }
    } else {
      setShowPageReqsMessage(true);
      shake();
      return false;
    }
  };

  const handleSubmitAndContinue = async (event) => {
    let x;
    if (residences) {
      residences.map((res) => {
        if (handlePageReqs(res)) {
          x = res;
        } else if(res.fromDate === "Extended Residence") {
          x = res;
        }
      });
    }
    // console.log(residences);
    if (x) {
      setShowPageReqsMessage(false);
      navigate("../phase2-employers");
      userData.residenceInfo = {
        isComplete: true,
        ...userData.residenceInfo,
      };
      await userService.saveUserData(user, "residenceInfo", {
        isComplete: true,
        ...userData.residenceInfo,
      });
      updatePage();
    }

    if (residences.length <= 0) {
      shake();
      setShowPageReqsMessage(true);
    }
  };

  // Assigning merged input names as keys for initialValues
  const inputKeys = residenceInputs.map((input) => {
    let keys = input.name;
    return keys;
  });

  // Creating initialValues by setting input keys to each have empty string value
  const initialValues = inputKeys.reduce((acc, key) => {
    acc[key] = "";
    return acc;
  }, {});

  const handleResidenceDelete = async (e) => {
    let index = e.target.value;
    let deletedRes = residences.splice(index, 1);
    residences.splice(index, 0);
    setResidences(residences);
    userData.residenceInfo = {
      extendedResidence: extendedAddress,
      residences: residences,
    };
    await userService.saveUserData(user, "residenceInfo", {
      extendedResidence: extendedAddress,
      residences: residences,
    });
    updatePage();
  };

  const handleFormikSubmit = async (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (values[key] === "" || !values[key]) {
        delete values[key];
      }
    });
    if (extendedAddress) {
      handleSkipStep();
    } else {
      userData.residenceInfo = {
        extendedResidence: extendedAddress,
        residences: [...residences, { ...values }],
      };
      await userService.saveUserData(user, "residenceInfo", {
        extendedResidence: extendedAddress,
        residences: [...residences, { ...values }],
      });
      actions.resetForm(initialValues);

      if (handlePageReqs(values)) {
        setShowPageReqsMessage(false);
      }
      const newResidences = [...residences, { ...values }]
      setResidences(newResidences);
    }
    updatePage();
  };

  useEffect(() => {
    if (userData && userData.residenceInfo) {
      setResidences(userData.residenceInfo.residences);
    }
    let date = new Date();
    let currentYear = date.getFullYear();
    setMinYear(currentYear - 7);
  });

  return (
    <>
      {/* {userData.residenceInfo && userData.residenceInfo.isComplete ? (
        <section className="main-section">
          <h2>Residence History</h2>
          <section className="main-section-content">
            <TaskComplete
              pageTitle={"Residences"}
              nextLink="phase2-employers"
            />
          </section>
        </section>
      ) : (
        <> */}
      {/* Extened Residence Modal  */}
      <Modal show={modalShow} centered>
        <ModalHeader as="span" className="alert alert-info">
          <ModalTitle as="h4">{t("residence.modal.title")}</ModalTitle>
        </ModalHeader>
        <ModalBody as="section">
          <p>{t("residence.modal.body1")}</p>
          <p>
            <Trans i18nKey="residence.modal.body2" components={{ strong: <strong /> }} />
          </p>
          <p>
            <Trans i18nKey="residence.modal.body3" components={{ strong: <strong /> }} />
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between" as="footer">
          <SaveAndContinueUserMessage messageType="save" />
          <Button onClick={handleFormikSubmit}>{t("common.save")}</Button>
          <Button variant="outline-primary" onClick={onModalHide}>
            {t("common.cancel")}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Page Instructions   */}
      <section className="main-section">
        <h2>{t("residence.historyTitle")}</h2>
        <section className="main-section-content text-start">
          <p>{t("residence.intro")}</p>

          <p>{t("residence.followDirections")}</p>
          {residences.length === 0 && (
            <div className="alert alert-info" role="alert">
              <p>{t("residence.pageReqs1")}</p>
              <p>{t("residence.pageReqs2")}</p>
            </div>
          )}
        </section>
      </section>

      {/* Form Section  */}
      <section className="main-section">
        <h2>{t("residence.formTitle")}</h2>
        <section className="main-section-content">
          {/* Form Section - Instructions  */}
          <section className="text-start">
            <p>{t("residence.formInstructions")}</p>
            <p>{t("residence.requiredFieldIndicator")}</p>

            <p>{t("residence.reviewInstructions")}</p>
          </section>

          {/* Form Section - Form  */}
          <ResidenceForm
            shake={shake}
            handleExtendedAddress={handleExtendedAddress}
            extendedAddress={extendedAddress}
            residences={residences}
            handleFormikSubmit={handleFormikSubmit}
            initialValues={initialValues}
            userData={userData}
            updatePage={updatePage}
            canUseSevenYearCheckbox={canUseSevenYearCheckbox}
          />
        </section>
      </section>

      {/* Review and Submit Section  */}
      <section className="main-section">
        <h2>{t("residence.reviewTitle")}</h2>
        <section className="main-section-content">
          {/* Review and Submit Section -  Instructions  */}
          <section className="text-start">
            <p>{t("residence.reviewDeleteInstructions")}</p>
            <p>{t("residence.reviewNextInstructions")}</p>
          </section>

          {/* Review and Submit Section - Review Table  */}
          <section
            style={{ border: "1px solid black", marginBottom: "1rem" }}
          >
            {residences.length > 0 ? (
              <Table
                striped
                bordered
                hover
                responsive
                size="sm"
                className="text-start"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>{t("residence.table.address")}</th>
                    <th>{t("residence.table.city")}</th>
                    <th>{t("residence.table.dates")}</th>
                  </tr>
                </thead>
                <tbody>
                  {residences.map((address, index) => (
                    <tr key={index}>
                      <td className="align-middle text-center">
                        <Button
                          variant="danger"
                          onClick={handleResidenceDelete}
                          value={index}
                          size="sm"
                          disabled={userData.submissionDate}
                        >
                          {t("residence.table.delete")}
                        </Button>
                      </td>
                      <td>
                        {address.address1}
                        <br />
                        {address.address2}
                      </td>
                      {/* <td>{address.address2}</td> */}
                      <td>{address.city}</td>
                      <td>
                        <strong>{t("residence.table.from")} </strong>
                        {address.fromDate} <br />
                        <strong>{t("residence.table.until")} </strong>
                        {address.untillDate}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="mb-0">{t("residence.noEntriesMessage")}</p>
            )}
          </section>

          {/* Review and Submit Section - Submit  */}
          <section>
            <RequiredFieldMessage
              handleClick={() => navigate("../phase2-employers")}
              show={showPageReqsMessage ? true : false}
              reqMessage={t("residence.pageReqMessage", { minYear })}
              hasButton={true}
            />
            <SaveAndContinueUserMessage messageType="save and continue" />
            <Button
              className="mb-3"
              variant="primary"
              onClick={handleSubmitAndContinue}
            >
              {t("common.saveAndContinue")}
            </Button>
          </section>
        </section>
      </section>
      {/* </>
      )} */}
    </>
  );
}
